export default __webpack_public_path__ + "static/media/backArrow.f05f4a93.svg";